<template>
  <div class="laryerBody">
    <!-- <div class=""></div> -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>机构管理</span>
        <el-button style="float: right; padding: 3px 0" type="text">新增机构</el-button>
      </div>
    <div class="cordBody">
         <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="laryerName"
        label="机构名称"
        >
      </el-table-column>
      <el-table-column
        prop="laryerTypa"
        label="机构类型"
       >
      </el-table-column>
      <el-table-column
        prop="uploadTime"
        label="录入时间">
      </el-table-column>
      <el-table-column
        prop="uploadUser"
        label="录入用户">
      </el-table-column>
     
      <el-table-column
        prop="uploadUser"
      
        label="操作">
         <template slot-scope="scope">
        <el-button
          size="mini"
           type="primary"
          >查看</el-button>
         
        <el-button
          size="mini"
          type="danger"
         >删除</el-button>
      </template>
      </el-table-column>
    </el-table>
    </div>
    </el-card>
  </div>
</template>

<script>
export default {
    data(){
        return{
             tableData: [
                
             ]
        }
    }
};
</script>

<style>
.laryerBody {
  height: 100%;
  width: 100%;
  padding:15px;
  background-color: rgb(244, 244, 244);
}
.box-card{
    height:100%;
    width:100%;
}
.cordBody{
   
   
}
</style>